import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { StyleSheet, css } from 'aphrodite';
import Isvg from 'react-inlinesvg';
import { Theme } from '../../config/theme';

const PIN_ASSET = require('./pin.svg');

export default class HorizontalRule extends Component {
  render() {
    const styles = StyleSheet.create({
      container: {
        position: 'relative',
        width: '100%',
        marginTop: this.props.margin,
        marginBottom: this.props.margin,
        [Theme.mobile_query]: {
          marginTop: this.props.margin / 2,
          marginBottom: this.props.margin / 2,
        },
      },
      line: {
        height: 1,
        backgroundColor: this.props.color,
        opacity: 0.45,
      },
      pin: {
        position: 'absolute',
        top: 2,
        right: '100%',
        transform: 'translateY(-50%)',
        [Theme.mobile_query]: {
          display: 'none',
        },
      },
    });

    return (
      <div className={css(styles.container)}>
        {this.props.pin ?
          <Isvg
            cacheGetRequests
            src={PIN_ASSET}
            className={css(styles.pin)}
          />
        : null}
        <div className={css(styles.line)} />
      </div>
    );
  }
}

HorizontalRule.defaultProps = {
  margin: 40,
  color: Theme.horizontal_rule_color,
  pin: false,
};

HorizontalRule.propTypes = {
  margin: PropTypes.number,
  color: PropTypes.string,
  pin: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/components/HorizontalRule/index.js